<div class="skeleton-custom d-flex" [ngClass]="{ reset: reset }">
  <ng-content></ng-content>
</div>
